import { CellText } from "assets/js/Styles";
import CustomCheckbox from "components/customs/checkbox";
import FormGenerator from "components/customs/form-generator/input";
import { ADD_ACTION, VIEW_ACTION } from "constants/actions";
import React from "react";
import { Check } from "react-feather";
import { UncontrolledTooltip } from "reactstrap";
import styled from "styled-components";
import { getFormattedNumber } from "utility/helpers";

const CheckboxContainer = styled.div`
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledFormGenerator = styled(FormGenerator)`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 0;
  padding: 2px 10px !important;
  height: 34px;
`;

const AddEndorsementColumns = ({
  handleBulkCheckboxOnChange,
  isAllChecked,
  action,
  courses,
  toggleCourseSelection,
  updateSlots,
}) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: (
        <CheckboxContainer>
          <CustomCheckbox
            icon={<Check size={16} />}
            onChange={(evt) => handleBulkCheckboxOnChange(evt)}
            checked={isAllChecked}
            disabled={action !== ADD_ACTION}
          />
        </CheckboxContainer>
      ),
      selector: (row) => row?.tviCourseId,
      sortable: false,
      width: "60px",
      cell: (record) => {
        const isChecked = courses?.some(
          (course) => course.tviCourseId === record.tviCourseId
        );

        return (
          <CheckboxContainer>
            <CustomCheckbox
              onChange={(evt) =>
                toggleCourseSelection(record, evt.target.checked)
              }
              disabled={action !== ADD_ACTION}
              icon={<Check size={16} />}
              checked={isChecked}
            />
          </CheckboxContainer>
        );
      },
    },
    {
      name: "Course",
      selector: (row) => row?.course,
      grow: 2,
      sortable: true,
      cell: ({ course }) => <CellText>{course}</CellText>,
    },
    {
      name: "Course Code",
      selector: null,
      sortable: false,
      cell: ({ courseCode }) => <CellText>{courseCode}</CellText>,
    },
    {
      name: "Cost / Slot",
      selector: (row) => row?.totalCost,
      sortable: true,
      cell: ({ totalCost }) => (
        <CellText>{getFormattedNumber(totalCost)}</CellText>
      ),
    },
    {
      name: "Available Slots",
      selector: (row) => row?.availableSlots,
      sortable: true,
      cell: ({ availableSlots }) => <CellText>{availableSlots}</CellText>,
    },
    {
      name: "Enter Slots",
      selector: (row) => row,
      sortable: true,
      grow: 1,
      cell: (record) => {
        const course = courses?.find(
          (crs) => crs.tviCourseId === record.tviCourseId
        );
        const isChecked = !!course;
        const enteredSlots = isChecked ? Number(course.slots) : 0;

        const maxSlots =
          action === ADD_ACTION
            ? record.availableSlots
            : (record?.oldSlotsValue ?? 0) +
              Number(record?.availableSlots ?? 0);

        const exceeds = enteredSlots > maxSlots;

        return (
          <>
            <StyledFormGenerator
              id={`slot-input-${record.tviCourseId}`}
              type="number"
              className={`${exceeds ? "is-invalid" : ""}`}
              value={isChecked ? course.slots : ""}
              disabled={!isChecked || action === VIEW_ACTION}
              onChange={(event) => updateSlots(record.tviCourseId, event.value)}
            />

            {exceeds && (
              <UncontrolledTooltip
                placement="top"
                target={`slot-input-${record.tviCourseId}`}
              >
                {"Entered slots cannot exceed available slots."}
              </UncontrolledTooltip>
            )}
          </>
        );
      },
    },
    {
      name: "Subtotal",
      selector: (row) => row,
      sortable: true,
      cell: ({ tviCourseId, totalCost }) => {
        const course = courses?.find((crs) => crs.tviCourseId === tviCourseId);

        const subTotal =
          Number(totalCost) *
          Number(course?.slots === undefined ? 0 : course?.slots);

        return <CellText>{getFormattedNumber(subTotal)}</CellText>;
      },
    },
  ];
};

export default AddEndorsementColumns;
